import { render, staticRenderFns } from "./search-filter-modal.vue?vue&type=template&id=3a1f570c"
import script from "./search-filter-modal.vue?vue&type=script&lang=js"
export * from "./search-filter-modal.vue?vue&type=script&lang=js"
import style0 from "./search-filter-modal.vue?vue&type=style&index=0&id=3a1f570c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
